<template>
  <div>
    <template v-if="is_mobile_view">
      <div class="w-100 border-b-semi-grey bg-white py-3 position-fixed z-index-1041" style="top:0;">
        <div class="ga-container">
          <div class="row">
            <div class="col-10 align-self-center no-ws" @click="goToPage('MerchantHome')">
              <img class="d-inline-block align-middle mr-2" :src="getMerchant.image_url" height="40"
                :alt="getMerchant.name">
              <p class="d-inline-block align-middle body-1-4 mb-0 text-truncate w-75">{{ getMerchant.name }}</p>
            </div>
            <div class="col-2 align-self-center text-right">
              <svg @click="toggleDetailMenu" class="lh-1 cursor-pointer" width="28" height="15" viewBox="0 0 28 15"
                fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_331_25)">
                  <path
                    d="M1.09465 14.1298H26.6864C27.2606 14.1298 27.7254 13.665 27.7254 13.0771C27.7254 12.5029 27.2606 12.0518 26.6864 12.0518H1.09465C0.520474 12.0518 0.0693359 12.5029 0.0693359 13.0771C0.0693359 13.665 0.520474 14.1298 1.09465 14.1298Z"
                    fill="black" fill-opacity="0.85" />
                  <path
                    d="M1.09465 8.15563H26.6864C27.2606 8.15563 27.7254 7.7045 27.7254 7.13033C27.7254 6.54248 27.2606 6.07767 26.6864 6.07767H1.09465C0.520474 6.07767 0.0693359 6.54248 0.0693359 7.13033C0.0693359 7.7045 0.520474 8.15563 1.09465 8.15563Z"
                    fill="black" fill-opacity="0.85" />
                  <path
                    d="M1.09465 2.19516H26.6864C27.2606 2.19516 27.7254 1.74402 27.7254 1.16984C27.7254 0.595668 27.2606 0.130859 26.6864 0.130859H1.09465C0.520474 0.130859 0.0693359 0.595668 0.0693359 1.16984C0.0693359 1.74402 0.520474 2.19516 1.09465 2.19516Z"
                    fill="black" fill-opacity="0.85" />
                </g>
                <defs>
                  <clipPath id="clip0_331_25">
                    <rect width="27.6561" height="14.04" fill="white" transform="translate(0.0693359 0.0898438)" />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </template>

    <header v-else class="position-fixed top-0 bg-white w-100 z-index-1040 py-2">
      <div class="ga-container">
        <div class="row">
          <div class="col-2 align-self-center py-2">
            <img class="cursor-pointer" @click="goToPage('MerchantHome')" :src="getMerchant.image_url" width="50"
              :alt="getMerchant.name">
          </div>
          <div class="col-10 text-right align-self-center">
            <div class="nav float-right">
              <div class="no-ws">
                <!-- ACCOMMODATIONS -->
                <router-link v-if="getMerchant.use_booking_engine" :to="`/${getMerchant.code}/booking`"
                  class="ml-4 menu-hover-bottom my-auto text-center h-fit-content d-inline-block"
                  @click.native="$trackHomeClick('NAVBAR','Clicked menu gallery')">
                  <div class="d-inline-block align-middle">
                    <svg class="lh-1" width="29" height="19" viewBox="0 0 29 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_493_15)">
                        <path
                          d="M0.956186 18.9774H1.63114C2.20486 18.9774 2.58732 18.6062 2.58732 18.0212V16.3564C2.71107 16.3901 3.08229 16.4127 3.35228 16.4127H25.1533C25.4233 16.4127 25.7945 16.3901 25.9183 16.3564V18.0212C25.9183 18.6062 26.3007 18.9774 26.8744 18.9774H27.5494C28.1344 18.9774 28.5056 18.6062 28.5056 18.0212V10.3156C28.5056 8.16695 27.3357 7.00828 25.1871 7.00828H3.31853C1.16992 7.00828 0 8.16695 0 10.3156V18.0212C0 18.6062 0.371225 18.9774 0.956186 18.9774ZM2.24985 14.7702C2.01362 14.7702 1.86737 14.6015 1.86737 14.3315V10.0569C1.86737 9.20188 2.42984 8.65067 3.30728 8.65067H25.2095C26.0758 8.65067 26.6382 9.20188 26.6382 10.0569V14.3315C26.6382 14.6015 26.492 14.7702 26.2558 14.7702H2.24985ZM2.92481 7.24452H5.88336V4.92717C5.88336 3.88099 6.46831 3.30727 7.53699 3.30727H11.4854C12.5429 3.30727 13.1279 3.88099 13.1279 4.92717V7.24452H15.3777V4.92717C15.3777 3.88099 15.9627 3.30727 17.0201 3.30727H20.9686C22.0372 3.30727 22.6222 3.88099 22.6222 4.92717V7.24452H25.5807V3.14979C25.5807 1.06868 24.4671 0 22.4422 0H6.06335C4.04973 0 2.92481 1.06868 2.92481 3.14979V7.24452Z"
                          class="menu-hover-bottom-icon" />
                      </g>
                      <defs>
                        <clipPath id="clip0_493_15">
                          <rect width="28.5056" height="19" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <p class="mb-0 body-2-1 d-inline-block align-middle ml-6px">{{$t('general.accomodation')}}</p>
                </router-link>

                <!-- FIND A TABLE -->
                <router-link v-if="is_order_route && pos_code" :to="{ name: 'PosBookingTable', params: { merchant_code: getMerchant.code, pos_code: pos_code } }"
                  class="ml-4 menu-hover-bottom my-auto text-center h-fit-content d-inline-block">
                  <div class="d-inline-block align-middle">
                    <svg width="24" height="19" viewBox="0 0 24 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M2.5 13.5H21.5V11.5H19.5V5.5C19.5 4.39543 18.6046 3.5 17.5 3.5H6.5C5.39543 3.5 4.5 4.39543 4.5 5.5V11.5H2.5V13.5ZM6.5 5.5H17.5V11.5H6.5V5.5ZM4.5 14.5V17.5H6.5V14.5H4.5ZM17.5 14.5V17.5H19.5V14.5H17.5Z" fill="black" fill-opacity="0.85"/>
                    </svg>
                  </div>
                  <p class="mb-0 body-2-1 d-inline-block align-middle ml-6px">Find a table</p>
                </router-link>

                <!-- CART -->
                <div v-if="!is_order_route" class="ml-4-5 menu-hover-bottom my-auto text-center h-fit-content d-inline-block cursor-pointer"
                  @click="goToPage('ConciergeSpaCart')">
                  <div class="d-inline-block align-middle position-relative">
                    <svg class="lh-1" width="23" height="21" viewBox="0 0 23 21" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_415_17)">
                        <path
                          d="M7.7559 15.4935H18.8798C19.2516 15.4935 19.5757 15.1884 19.5757 14.7786C19.5757 14.3687 19.2516 14.0637 18.8798 14.0637H7.91795C7.37462 14.0637 7.04101 13.6823 6.95522 13.1009L5.39196 2.49173C5.29664 1.75777 5.02974 1.38601 4.05747 1.38601H0.71172C0.330438 1.38601 0.00634766 1.71963 0.00634766 2.10092C0.00634766 2.49173 0.330438 2.82536 0.71172 2.82536H3.93355L5.45868 13.2916C5.65886 14.6451 6.37376 15.4935 7.7559 15.4935ZM6.00201 12.1H18.8989C20.2906 12.1 21.0055 11.2421 21.2056 9.87911L21.9682 4.83661C21.9872 4.7127 22.0063 4.56019 22.0063 4.4744C22.0063 4.01686 21.6632 3.7023 21.1389 3.7023H5.17272L5.18225 5.14164H20.3859L19.7091 9.70748C19.6328 10.2985 19.3183 10.6702 18.7559 10.6702H5.98295L6.00201 12.1ZM8.50892 20.126C9.36681 20.126 10.0532 19.4493 10.0532 18.5819C10.0532 17.724 9.36681 17.0376 8.50892 17.0376C7.64152 17.0376 6.95522 17.724 6.95522 18.5819C6.95522 19.4493 7.64152 20.126 8.50892 20.126ZM17.4214 20.126C18.2889 20.126 18.9751 19.4493 18.9751 18.5819C18.9751 17.724 18.2889 17.0376 17.4214 17.0376C16.5636 17.0376 15.8677 17.724 15.8677 18.5819C15.8677 19.4493 16.5636 20.126 17.4214 20.126Z"
                          class="menu-hover-bottom-icon" />
                      </g>
                      <defs>
                        <clipPath id="clip0_415_17">
                          <rect width="22" height="20.084" fill="white" transform="translate(0.00634766 0.0419922)" />
                        </clipPath>
                      </defs>
                    </svg>
                    <div v-if="getTicketCart.qty>0" class="bg-danger position-absolute rounded-6 lh-1"
                      style="top: -11px; right:-9px;padding:3px 5px">
                      <p class="mb-0 text-12 font-lato text-white lh-1 no-hover">{{getTicketCart.qty}}</p>
                    </div>
                  </div>
                  <p class="mb-0 body-2-4 d-inline-block align-middle ml-6px">Cart</p>
                </div>

                <!-- CURRENCY AND LANGUAGE -->
                <div class="ml-4-5 menu-hover-bottom my-auto text-center h-fit-content d-inline-block cursor-pointer"
                  @click="toggleShowLanguagePopup(true)">
                  <img class="d-inline-block align-middle border-semi-grey radius-3" :src="current_language.image_url"
                    width="22" alt="Language">
                  <p class="mb-0 body-2-4 d-inline-block align-middle ml-6px"><span
                      class="text-uppercase">{{ current_language.iso_code }} / {{ getCurrency.code }}</span>
                    ({{ getCurrency.symbol_native }})</p>
                </div>

                <!-- AUTH -->
                <div v-if="getMerchant.use_user_menu" class="d-inline-block align-middle ml-4-5 pl-4-5 border-l-semi-grey-2">
                  <button v-if="!isLoggedIn" class="g-btn g-btn-md g-btn-primary-outline"
                    @click="$openAuthModal({ view: 'login' })">SIGN IN</button>
                  <div class="no-ws menu-hover-bottom cursor-pointer" v-else @click="goToPage('Account')">
                    <div class="d-inline-block align-middle rounded-100 border-semi-grey overflow-hidden"
                      style="height: 22px;width: 22px;">
                      <img class="img-fit" :src="getCurrentUser.avatar" alt="User Avatar">
                    </div>
                    <p class="mb-0 body-2-4 d-inline-block align-middle ml-6px">{{getCurrentUser.first_name}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>

    <popup-detail id_ref="detail_menu" direction="right" :show="detail_menu" :size="75" @close="toggleDetailMenu">
      <template v-slot:body>
        <div>
          <div class="p-4 bg-light-page text-center border-b-form">
            <img class="mb-3" :src="getMerchant.image_url" height="70" :alt="getMerchant.name">
            <p class="mb-0 body-1-4">{{ getMerchant.name }}</p>
          </div>
          <div class="p-2">
            <!-- HOME -->
            <div class="p-3 radius-6 cursor-pointer" :class="{
              'bg-green-light-2': current_route == 'MerchantHome'
            }" @click="goToPage('MerchantHome')">
              <div class="row no-gutters">
                <div class="col-2 col-md-1">
                  <svg class="lh-1" width="22" height="21" viewBox="0 0 22 21" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M8.34103 18.4078H13.659V11.6981C13.659 11.2742 13.3824 10.9977 12.9585 10.9977H9.05067C8.61747 10.9977 8.34103 11.2742 8.34103 11.6981V18.4078ZM4.73732 19.3571H17.2073C18.5161 19.3571 19.2811 18.6106 19.2811 17.3203V7.13593L17.7972 6.12211V16.9424C17.7972 17.5414 17.4747 17.8733 16.894 17.8733H5.05069C4.46083 17.8733 4.13824 17.5414 4.13824 16.9424V6.13133L2.65437 7.13593V17.3203C2.65437 18.6106 3.41935 19.3571 4.73732 19.3571ZM0 9.09904C0 9.47694 0.29493 9.83636 0.792623 9.83636C1.05069 9.83636 1.26267 9.69818 1.45622 9.54143L10.682 1.79954C10.8847 1.6152 11.1336 1.6152 11.3364 1.79954L20.5622 9.54143C20.7465 9.69818 20.9585 9.83636 21.2166 9.83636C21.6497 9.83636 22 9.56912 22 9.12672C22 8.85019 21.9078 8.66592 21.7143 8.49997L12.1198 0.435483C11.4378 -0.145161 10.5898 -0.145161 9.89857 0.435483L0.29493 8.49997C0.0921662 8.66592 0 8.88708 0 9.09904ZM16.9677 4.94239L19.2811 6.8963V2.63824C19.2811 2.23272 19.023 1.97465 18.6175 1.97465H17.6313C17.235 1.97465 16.9677 2.23272 16.9677 2.63824V4.94239Z"
                      fill="black" fill-opacity="0.85" />
                  </svg>
                </div>
                <div class="col-10">
                  <p class="mb-0 body-2-4 d-inline-block align-middle">Home</p>
                </div>
              </div>
            </div>

            <!-- ACCOMODATIONS -->
            <div class="p-3 radius-6 cursor-pointer" @click="goToPage('BERoom')">
              <div class="row no-gutters">
                <div class="col-2 col-md-1 lh-1">
                  <svg class="lh-1" width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_493_15)">
                      <path
                        d="M0.805052 15.9779H1.37332C1.85636 15.9779 2.17837 15.6653 2.17837 15.1728V13.7711C2.28256 13.7995 2.59511 13.8185 2.82242 13.8185H21.1776C21.4049 13.8185 21.7175 13.7995 21.8216 13.7711V15.1728C21.8216 15.6653 22.1436 15.9779 22.6267 15.9779H23.1949C23.6875 15.9779 24 15.6653 24 15.1728V8.68509C24 6.87609 23.015 5.90055 21.206 5.90055H2.794C0.985004 5.90055 0 6.87609 0 8.68509V15.1728C0 15.6653 0.31255 15.9779 0.805052 15.9779ZM1.89424 12.4357C1.69535 12.4357 1.57222 12.2936 1.57222 12.0663V8.46728C1.57222 7.74744 2.04578 7.28335 2.78453 7.28335H21.2249C21.9543 7.28335 22.4278 7.74744 22.4278 8.46728V12.0663C22.4278 12.2936 22.3047 12.4357 22.1058 12.4357H1.89424ZM2.46251 6.09945H4.95344V4.14838C4.95344 3.26756 5.44594 2.78453 6.3457 2.78453H9.67006C10.5604 2.78453 11.0529 3.26756 11.0529 4.14838V6.09945H12.9471V4.14838C12.9471 3.26756 13.4396 2.78453 14.3299 2.78453H17.6543C18.554 2.78453 19.0466 3.26756 19.0466 4.14838V6.09945H21.5375V2.65193C21.5375 0.899763 20.5999 0 18.895 0H5.10498C3.40963 0 2.46251 0.899763 2.46251 2.65193V6.09945Z"
                        fill="black" fill-opacity="0.85" />
                    </g>
                    <defs>
                      <clipPath id="clip0_493_15">
                        <rect width="24" height="15.9969" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div class="col-10 lh-1">
                  <p class="mb-0 body-2-1 d-inline-block align-middle">Accomodation</p>
                </div>
              </div>
            </div>

            <!-- FIND A TABLE -->
            <div v-if="is_order_route && pos_code" class="p-3 radius-6 cursor-pointer" @click="goToPage('PosBookingTable')">
              <div class="row no-gutters">
                <div class="col-2 col-md-1 lh-1">
                  <svg width="24" height="19" viewBox="0 0 24 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2.5 13.5H21.5V11.5H19.5V5.5C19.5 4.39543 18.6046 3.5 17.5 3.5H6.5C5.39543 3.5 4.5 4.39543 4.5 5.5V11.5H2.5V13.5ZM6.5 5.5H17.5V11.5H6.5V5.5ZM4.5 14.5V17.5H6.5V14.5H4.5ZM17.5 14.5V17.5H19.5V14.5H17.5Z" fill="black" fill-opacity="0.85"/>
                  </svg>
                </div>
                <div class="col-10 lh-1">
                  <p class="mb-0 body-2-1 d-inline-block align-middle">Find a table</p>
                </div>
              </div>
            </div>

            <!-- CART -->
            <div class="p-3 radius-6 cursor-pointer" :class="{
              'bg-green-light-2': current_route == 'ConciergeSpaCart'
            }" @click="goToPage('ConciergeSpaCart')">
              <div class="row no-gutters">
                <div class="col-2 col-md-1 lh-1 align-self-center">
                  <svg class="lh-1" width="23" height="21" viewBox="0 0 23 21" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_415_17)">
                      <path
                        d="M7.7559 15.4935H18.8798C19.2516 15.4935 19.5757 15.1884 19.5757 14.7786C19.5757 14.3687 19.2516 14.0637 18.8798 14.0637H7.91795C7.37462 14.0637 7.04101 13.6823 6.95522 13.1009L5.39196 2.49173C5.29664 1.75777 5.02974 1.38601 4.05747 1.38601H0.71172C0.330438 1.38601 0.00634766 1.71963 0.00634766 2.10092C0.00634766 2.49173 0.330438 2.82536 0.71172 2.82536H3.93355L5.45868 13.2916C5.65886 14.6451 6.37376 15.4935 7.7559 15.4935ZM6.00201 12.1H18.8989C20.2906 12.1 21.0055 11.2421 21.2056 9.87911L21.9682 4.83661C21.9872 4.7127 22.0063 4.56019 22.0063 4.4744C22.0063 4.01686 21.6632 3.7023 21.1389 3.7023H5.17272L5.18225 5.14164H20.3859L19.7091 9.70748C19.6328 10.2985 19.3183 10.6702 18.7559 10.6702H5.98295L6.00201 12.1ZM8.50892 20.126C9.36681 20.126 10.0532 19.4493 10.0532 18.5819C10.0532 17.724 9.36681 17.0376 8.50892 17.0376C7.64152 17.0376 6.95522 17.724 6.95522 18.5819C6.95522 19.4493 7.64152 20.126 8.50892 20.126ZM17.4214 20.126C18.2889 20.126 18.9751 19.4493 18.9751 18.5819C18.9751 17.724 18.2889 17.0376 17.4214 17.0376C16.5636 17.0376 15.8677 17.724 15.8677 18.5819C15.8677 19.4493 16.5636 20.126 17.4214 20.126Z"
                        fill="black" fill-opacity="0.85" />
                    </g>
                    <defs>
                      <clipPath id="clip0_415_17">
                        <rect width="22" height="20.084" fill="white" transform="translate(0.00634766 0.0419922)" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div class="col-8 lh-1 align-self-center">
                  <p class="mb-0 body-2-1 d-inline-block align-middle">Cart</p>
                </div>
                <div class="col-2 col-md-1 lh-1 align-self-center text-right" v-if="getTicketCart.qty > 0">
                  <p class="mb-0 text-14 lh-1 font-bold text-danger font-lato">{{ getTicketCart.qty }}</p>
                </div>
              </div>
            </div>

            <!-- CURRENCY AND LANGUAGE -->
            <div class="p-3 radius-6 cursor-pointer" @click="menuClicked('currency_language')">
              <div class="row no-gutters">
                <div class="col-2 col-md-1 lh-1">
                  <img class="d-inline-block align-middle border-semi-grey radius-3" :src="current_language.image_url"
                    width="22" alt="Language">
                </div>
                <div class="col-10 lh-1">
                  <p class="mb-0 body-2-1 d-inline-block align-middle"><span
                      class="text-uppercase">{{ current_language.iso_code }} / {{ getCurrency.code }}</span>
                    ({{ getCurrency.symbol_native }})</p>
                </div>
              </div>
            </div>

            <!-- ACCOUNT -->
            <template v-if="getMerchant.use_user_menu">
              <div v-if="isLoggedIn" class="p-3 radius-6 cursor-pointer" :class="{
                'bg-green-light-2': current_route == 'Account'
              }" @click="goToPage('Account')">
                <div class="row no-gutters">
                  <div class="col-2 col-md-1 lh-1">
                    <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_419_21)">
                        <path
                          d="M2.64436 19.9892H16.2116C18.0033 19.9892 18.856 19.4496 18.856 18.2623C18.856 15.4344 15.2834 11.3438 9.43338 11.3438C3.5726 11.3438 0 15.4344 0 18.2623C0 19.4496 0.852673 19.9892 2.64436 19.9892ZM2.13708 18.3595C1.85645 18.3595 1.73773 18.2839 1.73773 18.0573C1.73773 16.2764 4.47923 12.9735 9.43338 12.9735C14.3767 12.9735 17.1182 16.2764 17.1182 18.0573C17.1182 18.2839 17.0103 18.3595 16.7297 18.3595H2.13708ZM9.43338 9.99466C12.0021 9.99466 14.0961 7.71723 14.0961 4.93255C14.0961 2.16946 12.013 0 9.43338 0C6.87535 0 4.77065 2.21263 4.77065 4.95414C4.77065 7.72802 6.86455 9.99466 9.43338 9.99466ZM9.43338 8.36483C7.85754 8.36483 6.50838 6.86455 6.50838 4.95414C6.50838 3.0761 7.83596 1.62979 9.43338 1.62979C11.0416 1.62979 12.3584 3.04372 12.3584 4.93255C12.3584 6.84297 11.0199 8.36483 9.43338 8.36483Z"
                          fill="black" fill-opacity="0.85" />
                      </g>
                      <defs>
                        <clipPath id="clip0_419_21">
                          <rect width="18.856" height="20" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <div class="col-10 lh-1">
                    <p class="mb-0 body-2-1 d-inline-block align-middle">Account</p>
                  </div>
                </div>
              </div>
              <div class="p-3" v-else>
                <button class="g-btn g-btn-primary-outline w-100 g-btn-lg" @click="openAuthFromDrawer()">SIGN IN</button>
              </div>
            </template>

            <div class="p-3 radius-6">
              <div class="w-100 border-2-bottom-dashed"></div>
            </div>
            <div class="p-3 text-center">
              <div class="d-inline-block align-middle mx-2 cursor-pointer" v-b-tooltip.hover :title="socmed.title"
                v-for="socmed in social_media" v-html="socmed.icon" @click="socmedClicked(socmed)">
              </div>
            </div>
          </div>
        </div>
      </template>
    </popup-detail>

    <GeneralLanguageCurrency :showPopup="showLanguagePopup" @togglePopup="toggleShowLanguagePopup" />
  </div>
</template>

<script>
  import {
    mapGetters,
    mapMutations
  } from 'vuex'
  import currency from "@/data/currency"
  import axios from 'axios';
  import english_img from '../../../../assets/img/icon/flag/united-states.png'
  import GeneralLanguageCurrency from '../../../general/GeneralLanguageCurrency.vue';

  export default {
    components:{
      GeneralLanguageCurrency
    },
    props: {
      page: {
        type: String,
        default: 'HOME'
      }
    },
    data() {
      return {
        currencys: currency,
        is_load: false,
        show_detail: false,
        detail_menu: false,
        scrollPosition: null,
        is_mobile_view: false,
        showLanguagePopup: false
      }
    },
    computed: {
      ...mapGetters(['getMerchant', 'isLoggedIn', 'getCurrentUser', 'getCurrentLanguage', 'getCurrency',
        'getTicketHeaderMenu', 'getTicketCart'
      ]),
      is_order_route() {
        return this.$route.path.includes('/order/')
      },
      pos_code() {
        return this.$route.params.pos_code
      },
      current_language() {
        let return_data = {
          name: "English",
          iso_code: "en",
          db_code: "en",
          image_url: english_img
        }
        if (this.getMerchant.language) {
          let lang_index = this.getMerchant.language.findIndex(x => x.iso_code == this.getCurrentLanguage)
          if (lang_index != -1) {
            return_data = this.getMerchant.language[lang_index]
          }
        }
        return return_data
      },
      current_route() {
        return this.$route.name
      },
      social_media() {
        let return_data = []
        if (this.$isNotEmpty(this.getMerchant.whatsapp_number)) {
          return_data.push({
            title: 'Whatsapp',
            value: this.getMerchant.whatsapp_number,
            icon: `<svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.5487 4.25C9.16775 4.25 3.97475 9.25175 3.9725 15.3988C3.971 17.3645 4.505 19.283 5.5175 20.9728L3.875 26.75L10.0122 25.1998C11.7194 26.0928 13.6176 26.5586 15.5442 26.5573H15.5487C21.9297 26.5573 27.1227 21.5548 27.125 15.4078C27.1265 12.4303 25.9235 9.6275 23.7372 7.52075C21.5517 5.41325 18.6455 4.25075 15.5487 4.25ZM15.5487 24.674H15.545C13.8185 24.674 12.125 24.227 10.6475 23.3825L10.295 23.1815L6.6545 24.101L7.6265 20.681L7.39775 20.3308C6.43693 18.8654 5.92545 17.151 5.92625 15.3988C5.9285 10.289 10.2455 6.13325 15.5525 6.13325C18.122 6.134 20.5377 7.09925 22.355 8.8505C24.1722 10.6018 25.172 12.9305 25.1705 15.407C25.1682 20.5168 20.852 24.674 15.548 24.674H15.5487ZM20.8265 17.7328C20.537 17.594 19.115 16.9198 18.8495 16.826C18.5847 16.7338 18.392 16.6858 18.1992 16.9648C18.0072 17.2438 17.4522 17.8715 17.2842 18.0568C17.1147 18.2428 16.946 18.2653 16.6565 18.1265C16.367 17.987 15.4347 17.693 14.3307 16.7435C13.4705 16.0055 12.89 15.0935 12.7212 14.8138C12.5525 14.5355 12.7032 14.3848 12.848 14.246C12.9777 14.1223 13.1375 13.9213 13.2815 13.7585C13.4255 13.5958 13.4735 13.4795 13.571 13.2935C13.667 13.1083 13.619 12.9448 13.5462 12.806C13.4735 12.6658 12.896 11.2948 12.6537 10.7375C12.4197 10.1945 12.1812 10.2673 12.0035 10.2583C11.8347 10.2508 11.6427 10.2485 11.4485 10.2485C11.2572 10.2485 10.943 10.3183 10.6775 10.5973C10.4127 10.8763 9.665 11.5498 9.665 12.9208C9.665 14.2925 10.7015 15.617 10.8462 15.803C10.991 15.9883 12.8862 18.803 15.788 20.0105C16.478 20.2963 17.0165 20.468 17.4372 20.597C18.1302 20.8093 18.761 20.7785 19.259 20.7073C19.814 20.627 20.9705 20.0338 21.2105 19.3835C21.452 18.7333 21.452 18.1753 21.38 18.059C21.3095 17.9428 21.116 17.873 20.8265 17.7328V17.7328Z" fill="#222"/></svg>`
          })
        }

        if (this.$isNotEmpty(this.getMerchant.website)) {
          return_data.push({
            title: 'Website',
            value: this.getMerchant.website,
            icon: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_265_49)"><path d="M11.9941 23.3297C15.263 23.3297 17.9324 18.4968 17.9324 12.0177C17.9324 5.50318 15.2749 0.670259 11.9941 0.670259C8.71336 0.670259 6.05585 5.50318 6.05585 12.0177C6.05585 18.4968 8.72512 23.3297 11.9941 23.3297ZM11.9941 2.09309C14.2989 2.09309 16.3567 6.67907 16.3567 12.0177C16.3567 17.2621 14.2989 21.8951 11.9941 21.8951C9.68935 21.8951 7.63154 17.2621 7.63154 12.0177C7.63154 6.67907 9.68935 2.09309 11.9941 2.09309ZM11.2298 0.834883V23.1062H12.7702V0.834883H11.2298ZM11.9941 16.4155C8.37235 16.4155 5.16217 17.3679 3.51592 18.8848L4.70357 19.8609C6.25575 18.6261 8.78392 17.9558 11.9941 17.9558C15.2042 17.9558 17.7325 18.6261 19.2847 19.8609L20.4722 18.8848C18.826 17.3679 15.6159 16.4155 11.9941 16.4155ZM22.8476 11.218H1.14062V12.7584H22.8476V11.218ZM11.9941 7.63154C15.6159 7.63154 18.826 6.67907 20.4722 5.16217L19.2847 4.18618C17.7325 5.4091 15.2042 6.09112 11.9941 6.09112C8.78392 6.09112 6.25575 5.4091 4.70357 4.18618L3.51592 5.16217C5.16217 6.67907 8.37235 7.63154 11.9941 7.63154ZM11.9941 23.9882C18.5556 23.9882 23.9882 18.5439 23.9882 11.9941C23.9882 5.43262 18.5439 0 11.9823 0C5.43262 0 0 5.43262 0 11.9941C0 18.5439 5.44438 23.9882 11.9941 23.9882ZM11.9941 22.389C6.31454 22.389 1.59921 17.6737 1.59921 11.9941C1.59921 6.31454 6.30278 1.59921 11.9823 1.59921C17.6619 1.59921 22.389 6.31454 22.389 11.9941C22.389 17.6737 17.6737 22.389 11.9941 22.389Z" fill="#222"/></g><defs><clipPath id="clip0_265_49"><rect width="23.9882" height="24" fill="white"/></clipPath></defs></svg>`
          })
        }

        if (this.$isNotEmpty(this.getMerchant.youtube_link)) {
          return_data.push({
            title: 'Youtube',
            value: this.getMerchant.youtube_link,
            icon: `<svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M25.5647 6.994C26.6757 7.29245 27.5545 8.17126 27.8529 9.28218C28.4001 11.3051 28.4167 15.5001 28.4167 15.5001C28.4167 15.5001 28.4167 19.7117 27.8695 21.718C27.571 22.8289 26.6922 23.7077 25.5813 24.0062C23.575 24.5534 15.5 24.5534 15.5 24.5534C15.5 24.5534 7.42502 24.5534 5.41871 24.0062C4.30778 23.7077 3.42898 22.8289 3.13052 21.718C2.58334 19.6951 2.58334 15.5001 2.58334 15.5001C2.58334 15.5001 2.58334 11.3051 3.11394 9.29877C3.4124 8.18784 4.2912 7.30904 5.40213 7.01058C7.40844 6.4634 15.4834 6.44682 15.4834 6.44682C15.4834 6.44682 23.5584 6.44682 25.5647 6.994ZM19.6121 15.5001L12.9134 19.3801V11.6201L19.6121 15.5001Z" fill="#222"/></svg>`
          })
        }

        if (this.$isNotEmpty(this.getMerchant.facebook_link)) {
          return_data.push({
            title: 'Facebook',
            value: this.getMerchant.facebook_link,
            icon: `<svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M28.4166 15.5784C28.4166 8.40099 22.6343 2.58333 15.5 2.58333C8.36567 2.58333 2.58331 8.40099 2.58331 15.5784C2.58331 22.066 7.30565 27.4419 13.4815 28.4167V19.3354H10.2024V15.5775H13.4815V12.7152C13.4815 9.45844 15.4096 7.65872 18.3606 7.65872C19.7728 7.65872 21.2522 7.91274 21.2522 7.91274V11.1109H19.6221C18.0179 11.1109 17.5184 12.1132 17.5184 13.1414V15.5784H21.1006L20.528 19.3345H17.5184V28.4167C23.6943 27.4419 28.4166 22.066 28.4166 15.5784Z" fill="#222"/></svg>`
          })
        }

        if (this.$isNotEmpty(this.getMerchant.instagram_link)) {
          return_data.push({
            title: 'Instagram',
            value: this.getMerchant.instagram_link,
            icon: `<svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.5 3.875C12.3426 3.875 11.9474 3.88818 10.7074 3.94475C9.46972 4.00132 8.6242 4.19817 7.88485 4.4857C7.10985 4.7771 6.40692 5.23435 5.82567 5.82645C5.23452 6.40703 4.77699 7.10946 4.48492 7.88485C4.19895 8.6242 4.00132 9.4705 3.94475 10.7082C3.88895 11.9474 3.875 12.3419 3.875 15.5C3.875 18.6581 3.88818 19.0526 3.94475 20.2926C4.00132 21.5303 4.19817 22.3758 4.4857 23.1151C4.7771 23.8901 5.23435 24.5931 5.82645 25.1743C6.40704 25.7655 7.10947 26.223 7.88485 26.5151C8.6242 26.8018 9.46972 26.9987 10.7074 27.0552C11.9474 27.1118 12.3426 27.125 15.5 27.125C18.6573 27.125 19.0526 27.1118 20.2926 27.0552C21.5303 26.9987 22.3758 26.8018 23.1151 26.5143C23.8901 26.2229 24.5931 25.7656 25.1743 25.1735C25.7655 24.593 26.223 23.8905 26.5151 23.1151C26.8018 22.3758 26.9987 21.5303 27.0552 20.2926C27.1118 19.0526 27.125 18.6573 27.125 15.5C27.125 12.3426 27.1118 11.9474 27.0552 10.7074C26.9987 9.46972 26.8018 8.6242 26.5143 7.88485C26.2224 7.10912 25.7649 6.4064 25.1735 5.82567C24.593 5.23452 23.8905 4.77699 23.1151 4.48492C22.3758 4.19895 21.5295 4.00132 20.2918 3.94475C19.0526 3.88895 18.6581 3.875 15.5 3.875ZM15.5 5.96982C18.6039 5.96982 18.972 5.98145 20.198 6.03725C21.3311 6.08917 21.9464 6.2775 22.3564 6.43792C22.8989 6.64795 23.2864 6.9006 23.6933 7.3067C24.1002 7.71357 24.352 8.10107 24.5621 8.64357C24.7217 9.05355 24.9108 9.6689 24.9627 10.8019C25.0185 12.028 25.0302 12.3961 25.0302 15.5C25.0302 18.6039 25.0185 18.972 24.9627 20.198C24.9108 21.3311 24.7225 21.9464 24.5621 22.3564C24.376 22.8614 24.0792 23.3182 23.6933 23.6933C23.3183 24.0792 22.8614 24.3761 22.3564 24.5621C21.9464 24.7217 21.3311 24.9108 20.198 24.9627C18.972 25.0185 18.6046 25.0302 15.5 25.0302C12.3953 25.0302 12.028 25.0185 10.8019 24.9627C9.6689 24.9108 9.05355 24.7225 8.64357 24.5621C8.13863 24.376 7.6818 24.0792 7.3067 23.6933C6.92089 23.3182 6.62402 22.8613 6.43792 22.3564C6.27827 21.9464 6.08917 21.3311 6.03725 20.198C5.98145 18.972 5.96982 18.6039 5.96982 15.5C5.96982 12.3961 5.98145 12.028 6.03725 10.8019C6.08917 9.6689 6.2775 9.05355 6.43792 8.64357C6.64795 8.10107 6.9006 7.71357 7.3067 7.3067C7.68175 6.92078 8.13859 6.62391 8.64357 6.43792C9.05355 6.27827 9.6689 6.08917 10.8019 6.03725C12.028 5.98145 12.3961 5.96982 15.5 5.96982V5.96982Z" fill="#222"/><path fill-rule="evenodd" clip-rule="evenodd" d="M15.5 19.3789C14.9906 19.3789 14.4862 19.2785 14.0156 19.0836C13.545 18.8887 13.1174 18.603 12.7572 18.2428C12.397 17.8826 12.1113 17.455 11.9164 16.9844C11.7215 16.5138 11.6211 16.0094 11.6211 15.5C11.6211 14.9906 11.7215 14.4862 11.9164 14.0156C12.1113 13.545 12.397 13.1174 12.7572 12.7572C13.1174 12.397 13.545 12.1113 14.0156 11.9164C14.4862 11.7215 14.9906 11.6211 15.5 11.6211C16.5287 11.6211 17.5153 12.0298 18.2428 12.7572C18.9702 13.4847 19.3789 14.4713 19.3789 15.5C19.3789 16.5287 18.9702 17.5154 18.2428 18.2428C17.5153 18.9702 16.5287 19.3789 15.5 19.3789V19.3789ZM15.5 9.52475C13.9153 9.52475 12.3954 10.1543 11.2749 11.2749C10.1543 12.3954 9.52475 13.9153 9.52475 15.5C9.52475 17.0847 10.1543 18.6046 11.2749 19.7251C12.3954 20.8457 13.9153 21.4753 15.5 21.4753C17.0847 21.4753 18.6046 20.8457 19.7251 19.7251C20.8457 18.6046 21.4752 17.0847 21.4752 15.5C21.4752 13.9153 20.8457 12.3954 19.7251 11.2749C18.6046 10.1543 17.0847 9.52475 15.5 9.52475V9.52475ZM23.2136 9.41625C23.2136 9.79085 23.0648 10.1501 22.7999 10.415C22.535 10.6799 22.1757 10.8287 21.8011 10.8287C21.4265 10.8287 21.0673 10.6799 20.8024 10.415C20.5375 10.1501 20.3887 9.79085 20.3887 9.41625C20.3887 9.04165 20.5375 8.68239 20.8024 8.41751C21.0673 8.15262 21.4265 8.00381 21.8011 8.00381C22.1757 8.00381 22.535 8.15262 22.7999 8.41751C23.0648 8.68239 23.2136 9.04165 23.2136 9.41625" fill="#222"/></svg>`
          })
        }

        if (this.$isNotEmpty(this.getMerchant.tiktok_link)) {
          return_data.push({
            title: 'Tiktok',
            value: this.getMerchant.tiktok_link,
            icon: `<svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M23.3992 7.76154C22.0077 6.85423 21.0033 5.40254 20.69 3.71026C20.6223 3.34463 20.5851 2.96834 20.5851 2.58333H16.1439L16.1367 20.3824C16.0621 22.3756 14.4216 23.9754 12.4105 23.9754C11.7855 23.9754 11.1969 23.8191 10.6787 23.5464C9.49041 22.9211 8.67718 21.6755 8.67718 20.2421C8.67718 18.1834 10.352 16.5086 12.4105 16.5086C12.7948 16.5086 13.1634 16.572 13.5121 16.6812V12.1471C13.1512 12.098 12.7846 12.0673 12.4105 12.0673C7.90294 12.0673 4.2359 15.7345 4.2359 20.2421C4.2359 23.0077 5.61767 25.4552 7.7257 26.9351C9.05352 27.8673 10.6686 28.4167 12.4105 28.4167C16.9181 28.4167 20.5851 24.7497 20.5851 20.2421V11.2164C22.3271 12.4667 24.4612 13.2034 26.7641 13.2034V8.76214C25.5236 8.76214 24.3682 8.39335 23.3992 7.76154" fill="#222"/></svg>`
          })
        }

        if (this.$isNotEmpty(this.getMerchant.tripadvisor_link)) {
          return_data.push({
            title: 'Tripadvisor',
            value: this.getMerchant.tripadvisor_link,
            icon: `<svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.3323 16.8088C11.3323 17.2619 11.198 17.7048 10.9463 18.0814C10.6946 18.4581 10.3368 18.7517 9.91827 18.9251C9.49971 19.0985 9.03914 19.1438 8.5948 19.0555C8.15045 18.9671 7.7423 18.7489 7.42195 18.4286C7.1016 18.1082 6.88344 17.7001 6.79505 17.2557C6.70667 16.8114 6.75203 16.3508 6.9254 15.9322C7.09877 15.5137 7.39237 15.1559 7.76907 14.9042C8.14576 14.6525 8.58863 14.5182 9.04168 14.5182C9.64919 14.5182 10.2318 14.7595 10.6614 15.1891C11.091 15.6187 11.3323 16.2013 11.3323 16.8088V16.8088ZM21.9526 14.5182C21.4996 14.5182 21.0567 14.6525 20.68 14.9042C20.3033 15.1559 20.0097 15.5137 19.8363 15.9322C19.663 16.3508 19.6176 16.8114 19.706 17.2557C19.7944 17.7001 20.0125 18.1082 20.3329 18.4286C20.6532 18.7489 21.0614 18.9671 21.5057 19.0555C21.9501 19.1438 22.4106 19.0985 22.8292 18.9251C23.2478 18.7517 23.6055 18.4581 23.8572 18.0814C24.1089 17.7048 24.2433 17.2619 24.2433 16.8088C24.2431 16.2016 24.0019 15.6194 23.5726 15.19C23.1433 14.7606 22.5611 14.5192 21.9539 14.5188L21.9526 14.5182ZM28.411 16.8088C28.411 20.3736 25.5184 23.2637 21.9526 23.2637C20.3261 23.2663 18.759 22.6524 17.567 21.5457L15.5 23.7947L13.4321 21.5431C12.2402 22.6511 10.6725 23.2659 9.04518 23.2637C5.48196 23.2637 2.59034 20.3736 2.59034 16.8088C2.58913 15.9108 2.77583 15.0224 3.13844 14.2008C3.50104 13.3792 4.03154 12.6426 4.69582 12.0383L2.58334 9.73998H7.27661C9.7033 8.08851 12.5707 7.20535 15.5061 7.20535C18.4414 7.20535 21.3088 8.08851 23.7355 9.73998H28.4167L26.3045 12.0383C26.969 12.6425 27.4998 13.3791 27.8626 14.2007C28.2254 15.0223 28.4123 15.9107 28.4113 16.8088H28.411ZM13.4117 16.8088C13.4117 15.9448 13.1555 15.1002 12.6755 14.3818C12.1954 13.6634 11.5132 13.1035 10.7149 12.7729C9.91668 12.4423 9.03831 12.3558 8.19091 12.5244C7.34351 12.6929 6.56513 13.109 5.9542 13.72C5.34328 14.331 4.92725 15.1094 4.75873 15.9568C4.5902 16.8042 4.67676 17.6826 5.00744 18.4808C5.33813 19.279 5.89809 19.9612 6.61652 20.4412C7.33495 20.9212 8.17958 21.1773 9.04359 21.1773C9.61727 21.1773 10.1853 21.0644 10.7154 20.8448C11.2454 20.6253 11.727 20.3035 12.1326 19.8979C12.5383 19.4922 12.8601 19.0106 13.0796 18.4806C13.2991 17.9506 13.4121 17.3825 13.412 16.8088H13.4117ZM20.3473 10.2869C18.8111 9.64685 17.1634 9.31734 15.4992 9.31734C13.835 9.31734 12.1873 9.64685 10.6512 10.2869C13.4092 11.3425 15.5 13.8081 15.5 16.6828C15.5 13.8084 17.5905 11.3425 20.3476 10.2872L20.3473 10.2869ZM26.322 16.8088C26.322 15.9448 26.0658 15.1002 25.5858 14.3818C25.1058 13.6634 24.4235 13.1035 23.6252 12.7729C22.827 12.4423 21.9486 12.3558 21.1012 12.5244C20.2538 12.6929 19.4754 13.109 18.8645 13.72C18.2536 14.331 17.8376 15.1094 17.669 15.9568C17.5005 16.8042 17.5871 17.6826 17.9178 18.4808C18.2484 19.279 18.8084 19.9612 19.5268 20.4412C20.2453 20.9212 21.0899 21.1773 21.9539 21.1773C23.1125 21.1773 24.2236 20.717 25.0428 19.8978C25.8621 19.0785 26.3223 17.9674 26.3223 16.8088H26.322Z" fill="#222"/></svg>`
          })
        }


        return return_data
      },
    },
    mounted() {
      window.addEventListener('scroll', this.updateScroll);
      this.onResizeWindow()
      this.$nextTick(() => {
        window.addEventListener('resize', this.onResizeWindow);
      })
    },
    destroyed() {
      window.removeEventListener('resize', this.onResizeWindow);
    },
    methods: {
      ...mapMutations(['setCurrency', 'setBaseRate', 'setLanguageMutation']),
      toggleShowLanguagePopup(show=false){
        this.showLanguagePopup = show
      },
      onResizeWindow(){
        this.is_mobile_view = window.innerWidth < 992
      },
      updateScroll() {
        this.scrollPosition = window.scrollY
      },
      /* the drawer owns the body scroll lock, so let it unmount before the popup opens */
      openAuthFromDrawer() {
        this.detail_menu = false;
        this.$nextTick(() => this.$openAuthModal({ view: 'login' }));
      },
      goToPage(page) {
        let params = {
          merchant_code: this.getMerchant.code
        }
        if (this.pos_code) {
          params.pos_code = this.pos_code
        }
        this.$router.push({
          name: page,
          params: params
        })
      },
      shareClick() {
        let value = window.location.href;
        this.$copyText(value, 'Successfully copy the url')
      },
      callClick() {
        setTimeout(() => {
          let tag_a = document.createElement('a')
          tag_a.href = `tel:${this.getMerchant.phone}`
          tag_a.click()
          tag_a.remove()
        }, 300)
      },
      toggleDetail() {
        this.show_detail = !this.show_detail
        if (this.show_detail && this.page != 'HOME') {
          this.toggleDetailMenu()
        }
      },
      toggleDetailMenu() {
        this.detail_menu = !this.detail_menu
      },
      changeCurrency(data) {
        this.is_load = true
        this.$convertCurrency(data.code)
        .then(()=>{
          this.setCurrency(data)
          this.toggleDetail()
        })
        .finally(()=>this.is_load)
      },
      changeLanguage(data) {
        console.log("data :", data)
        this.setLanguageMutation(data)
        window.location.reload();
      },
      menuClicked(to) {
        if (to == 'review') {
          this.$trackHomeClick('NAVBAR', 'Clicked menu review')
          if (this.$route.name == 'MerchantHome') {
            this.$smoothScroll('home-review')
            if (this.is_mobile_view) {
              this.detail_menu = false
            }
          } else {
            this.$router.push({
              name: 'MerchantHome',
              params: {
                merchant_code: this.getMerchant.code
              },
              hash: '#review'
            })
          }
        } else if (to == 'currency_language') {
          this.show_detail = true
          this.detail_menu = false
          this.toggleShowLanguagePopup(true);
        }
      },
      socmedClicked(data) {
        let url = data.title == 'Whatsapp' ? `https://api.whatsapp.com/send/?phone=${data.value}&text&app_absent=0` :
          data.value

        this.$openLink(url, '_blank')
      },
    }
  }

</script>
<style scoped>
  .mobile-navbar-item {
    background-color: #fff;
    border-radius: 100%;
    padding: 12.5px 6px;
    position: relative;
    display: inline-block;
    vertical-align: middle;
    margin-left: 10px;
    cursor: pointer;
  }

  /* .mobile-navbar-item img:not(.porfile){
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 1;
  margin: -9px 0px 0px -9px;
} */
  .show-desktop {
    display: block;
  }

  .show-mobile {
    display: none;
  }

  .hide-576px {
    display: block;
  }

  .header-fixed {
    position: fixed;
    width: 100%;
    top: -1px;
    height: 80.8px;
    background-color: #fff;
    z-index: 9;
  }

  .ml-6px {
    margin-left: 6px;
  }

  @media screen and (max-width: 1200px) {
    .show-desktop {
      display: none;
    }

    .show-mobile {
      display: block;
    }

    .px-10 {
      padding-left: 3rem;
      padding-right: 3rem;
    }
  }

  @media screen and (max-width: 576px) {
    .hide-576px {
      display: none;
    }

    .px-10 {
      padding-left: 24px;
      padding-right: 24px;
    }

    .text-20-m {
      font-size: 20px !important;
    }

    .text-17-m {
      font-size: 17px !important;
    }

    .text-14-m {
      font-size: 14px !important;
    }

    .room-type-border-m {
      border: 1px solid #ddd;
      padding-bottom: 0px !important;
      border-radius: 6px;
    }

    .room-type-desc-m {
      padding: 16px !important;
    }

    .p-0-m {
      padding: 0 !important;
    }

    .h-270px-m {
      height: 270px !important;
    }

    .px-7 {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/hotel/concierge/general/Navbar.vue